import { cn } from '../utils'

export function XCloseIcon({
  width = 24,
  height = 24,
  className = '',
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      className={cn('stroke-[#98A2B3] stroke-2', className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M18 6.5L6 18.5M6 6.5L18 18.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
